// extracted by mini-css-extract-plugin
export default {"userInfo":"Profile_userInfo__4Vx50","buttonPadding":"Profile_buttonPadding__67RzK","page":"Profile_page__5c9tN","bottomWrapper":"Profile_bottomWrapper__2TNWJ"};